"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getFormattedDateRange = void 0;
const date_fns_1 = require("date-fns");
const intl_1 = require("../locale/intl");
const texts_1 = require("../texts");
const date_1 = require("../utils/date");
/**
 * Returns formatted strings for date range
 *
 * @param dateRange           Initial DateRange
 * @param userPreferences     Current user preferences
 * @param fieldDisplayFormat  Field display format
 * @param hideTime            Flag for remove time from result
 * @param includeYear         Flag for showing year in result
 */
const getFormattedDateRange = (dateRange, userPreferences, fieldDisplayFormat, hideTime = false, includeYear = false) => {
    const displayFormat = fieldDisplayFormat === "pill" ? "standard" : fieldDisplayFormat;
    return convertValueToDisplayFormat(dateRange, userPreferences, displayFormat, hideTime, includeYear);
};
exports.getFormattedDateRange = getFormattedDateRange;
function capitalize(str) {
    const newStr = str.split(" ");
    return newStr
        .map((item) => item.charAt(0).toUpperCase() + item.slice(1))
        .join(" ");
}
const convertValueToDisplayFormat = (dateRange, userPreferences, displayFormat, hideTime, includeYear) => {
    var _a, _b, _c;
    const timezone = (_a = userPreferences === null || userPreferences === void 0 ? void 0 : userPreferences.timezone) === null || _a === void 0 ? void 0 : _a.value;
    const fromDate = (0, date_1.dateValueToDate)(dateRange === null || dateRange === void 0 ? void 0 : dateRange.from_date, timezone);
    const toDate = (0, date_1.dateValueToDate)(dateRange === null || dateRange === void 0 ? void 0 : dateRange.to_date, timezone);
    const isValidFromDate = !!fromDate && (0, date_1.isDateValid)(fromDate);
    const isValidToDate = !!toDate && (0, date_1.isDateValid)(toDate);
    if (!isValidFromDate && !isValidToDate) {
        return {
            from_date: { date: null, include_time: false },
            to_date: { date: null, include_time: false },
        };
    }
    const now = (0, date_1.getNow)(timezone);
    const removeFromYear = !includeYear &&
        isValidFromDate &&
        isValidToDate &&
        (0, date_fns_1.isSameYear)(fromDate, toDate) &&
        (0, date_fns_1.isSameYear)(fromDate, now);
    const removeToYear = !includeYear &&
        isValidFromDate &&
        isValidToDate &&
        (0, date_fns_1.isSameYear)(fromDate, toDate);
    let formattedFromDate = isValidFromDate
        ? (0, date_1.getFormattedDate)(fromDate, userPreferences, displayFormat, removeFromYear)
        : "";
    let formattedToDate = isValidToDate
        ? (0, date_1.getFormattedDate)(toDate, userPreferences, displayFormat, removeToYear)
        : "";
    if (displayFormat === "long") {
        formattedFromDate = capitalize(formattedFromDate);
        formattedToDate = capitalize(formattedToDate);
    }
    if (isValidFromDate && !hideTime && dateRange.from_date.include_time) {
        const formattedTime = (0, date_1.fnsFormatTime)(fromDate, userPreferences);
        formattedFromDate = (0, intl_1.$t)(texts_1.dateText.date_at_time, {
            formattedDate: formattedFromDate,
            formattedTime,
        });
    }
    if (isValidToDate && !hideTime && dateRange.to_date.include_time) {
        const formattedTime = (0, date_1.fnsFormatTime)(toDate, userPreferences);
        formattedToDate = (0, intl_1.$t)(texts_1.dateText.date_at_time, {
            formattedDate: formattedToDate,
            formattedTime,
        });
    }
    return {
        from_date: {
            date: formattedFromDate,
            include_time: !!((_b = dateRange === null || dateRange === void 0 ? void 0 : dateRange.from_date) === null || _b === void 0 ? void 0 : _b.include_time),
        },
        to_date: {
            date: formattedToDate,
            include_time: !!((_c = dateRange === null || dateRange === void 0 ? void 0 : dateRange.to_date) === null || _c === void 0 ? void 0 : _c.include_time),
        },
    };
};
